/* Página do carrinho - cupom de desconto e cálculo de frete por CEP */
(function () {
  function money(value) {
    var format =
      (window.themeGlobalVariables &&
        window.themeGlobalVariables.settings &&
        window.themeGlobalVariables.settings.money_format) ||
      '{{ amount }}';
    return window.Shopify.formatMoney(value, format);
  }

  function setMessage(element, text, state) {
    if (!element) return;
    element.textContent = text || '';
    element.classList.remove('ec-cart-message--error', 'ec-cart-message--success');
    if (state) element.classList.add('ec-cart-message--' + state);
  }

  class EcCartCoupon extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('[data-ec-coupon-input]');
      this.button = this.querySelector('[data-ec-coupon-button]');
      this.message = this.querySelector('[data-ec-message]');

      this.button.addEventListener('click', this.onSubmit.bind(this));
      this.input.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        this.onSubmit(event);
      });
    }

    onSubmit(event) {
      event.preventDefault();
      const code = this.input.value.trim();
      if (!code) {
        setMessage(this.message, this.dataset.emptyError, 'error');
        this.input.focus();
        return;
      }
      // /discount/<code> aplica o cupom à sessão do carrinho e redireciona de volta.
      this.button.setAttribute('disabled', '');
      window.location.href =
        window.Shopify.routes.root +
        'discount/' +
        encodeURIComponent(code) +
        '?redirect=' +
        encodeURIComponent(window.Shopify.routes.root + 'cart');
    }
  }
  if (!customElements.get('ec-cart-coupon')) customElements.define('ec-cart-coupon', EcCartCoupon);

  class EcCartShipping extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('[data-ec-zip-input]');
      this.button = this.querySelector('[data-ec-zip-button]');
      this.message = this.querySelector('[data-ec-message]');
      this.shippingValue = document.querySelector('[data-ec-shipping-value]');

      this.button.addEventListener('click', this.onSubmit.bind(this));
      this.input.addEventListener('input', this.onInput.bind(this));
      this.input.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        this.onSubmit(event);
      });
    }

    onInput() {
      const digits = this.input.value.replace(/\D/g, '').slice(0, 8);
      this.input.value = digits.length > 5 ? digits.slice(0, 5) + '-' + digits.slice(5) : digits;
    }

    onSubmit(event) {
      event.preventDefault();
      const zip = this.input.value.replace(/\D/g, '');
      if (zip.length !== 8) {
        setMessage(this.message, this.dataset.invalidZip, 'error');
        this.input.focus();
        return;
      }

      this.button.setAttribute('disabled', '');
      setMessage(this.message, this.dataset.loadingText);

      this.getProvince(zip)
        .then((province) => this.getRates(zip, province))
        .then((rates) => this.renderRates(rates))
        .catch(() => setMessage(this.message, this.dataset.errorText, 'error'))
        .finally(() => this.button.removeAttribute('disabled'));
    }

    // A maioria das transportadoras exige a UF; o CEP sozinho não a informa.
    getProvince(zip) {
      return fetch('https://viacep.com.br/ws/' + zip + '/json/')
        .then((response) => (response.ok ? response.json() : null))
        .then((data) => (data && !data.erro ? data.uf : ''))
        .catch(() => '');
    }

    getRates(zip, province) {
      const params = new URLSearchParams({
        'shipping_address[zip]': zip,
        'shipping_address[country]': this.dataset.country || 'Brazil',
        'shipping_address[province]': province || ''
      });
      return fetch(window.Shopify.routes.root + 'cart/shipping_rates.json?' + params.toString())
        .then((response) => response.json())
        .then((data) => {
          if (!data || !data.shipping_rates) throw new Error('no rates');
          return data.shipping_rates;
        });
    }

    renderRates(rates) {
      if (!rates.length) {
        setMessage(this.message, this.dataset.noShipping, 'error');
        return;
      }

      this.message.classList.remove('ec-cart-message--error', 'ec-cart-message--success');
      this.message.innerHTML = rates
        .map((rate) => '<span>' + rate.name + ': ' + money(rate.price) + '</span>')
        .join('<br>');

      if (!this.shippingValue || this.shippingValue.dataset.ecShippingFree === 'true') return;
      const cheapest = rates.reduce((a, b) => (parseFloat(a.price) <= parseFloat(b.price) ? a : b));
      this.shippingValue.textContent =
        parseFloat(cheapest.price) === 0 ? this.dataset.freeLabel : money(cheapest.price);
    }
  }
  if (!customElements.get('ec-cart-shipping')) customElements.define('ec-cart-shipping', EcCartShipping);
})();
